import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TokenService } from '@services/token/token.service';
import { Observable } from 'rxjs';
import { IS_API_REQUEST } from '@tokens/api-request.token';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  tokenService = inject(TokenService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.context.get(IS_API_REQUEST)) {
      return next.handle(req);
    }

    const token = this.tokenService.getToken();
    const headers = req.headers
      .set('Content-Type', req.headers.get('Content-Type') || 'application/json')
      .set('Accept', req.headers.get('Accept') || 'application/json')
      .set('authorization', token || '');

    const authReq = req.clone({ headers });
    return next.handle(authReq);
  }
}
